
import { Form, Input, Icon, Button, Row, Col,  Select,  Divider } from 'antd';
import React from 'react'
import MiCompAPI from '../../../util/api';
import InputMask from "react-input-mask";
let id = 0;
const { Option } = Select;
class EAD extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isloding: false, 
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.keys.length > 0) {
          let affiliations = [];
          let { entitY_NAME, fein, npn, statE_COMPANY_ID } = values;
          Object.keys(entitY_NAME).forEach(function (i) {
            affiliations.push({
              entitY_NAME: entitY_NAME[i],
              fein: fein[i], npn: npn[i], statE_COMPANY_ID: statE_COMPANY_ID[i]
            })
          });
          this.props.submitHandler({ affiliation: affiliations });
        } else {
          this.props.submitHandler({ affiliation: [] });

        }

      }
    });
  }
  remove = (k) => {

    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue('keys');
    // We need at least one passenger


    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    });
  };

  add = () => {
    const { form } = this.props;
    // can use data-binding to get
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);
    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys,
    });
  };
 

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { States} = this.props;
    let { affiliation } = this.props.niprappoinment;

    getFieldDecorator('keys', { initialValue:this.props.niprappoinment&&affiliation?affiliation: [] });
    const keys = getFieldValue('keys');
    const formItems = keys.map((k, index) => (<div key={k} >
        <Row key={index}>
          <Col md={12} sm={24}>

            <Form.Item>

              <fieldset className="mi_input_pop">
                <legend className="legend-font">Agency Name *</legend>
                {getFieldDecorator(`entitY_NAME[${k}]`, {
                  initialValue: k.entitY_NAME,

                  rules: [
                    {
                      required: true,
                      message: "Please enter agency name",
                    },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
                      message: "It allows only Alphanumerics"
                    }
                  ],
                })(<Input autoComplete={"nope"} maxLength={100} className="mi_input" placeholder="Enter Agency Name" />)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item


            >
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Agency FEIN *</legend>
                {getFieldDecorator(`fein[${k}]`, {
initialValue: k.fein,
                  rules: [
                    {
                      required: true,

                      message: "Please enter FEIN.",
                    },

                  ],
                })(<InputMask mask="999999999"  className="ant-input mi_input" placeholder='Enter FEIN ' />)}
              </fieldset>
            </Form.Item>
          </Col></Row>
        <Row>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">Agency NPN</legend>
                {getFieldDecorator(`npn[${k}]`, {
initialValue: k.npn,

                  rules: [
                    {
                      required: false,

                      message: "Please enter agency NPN.",
                    },

                  ],
                })(<InputMask mask="9999999999"  className="ant-input mi_input" placeholder='Enter Agency NPN ' />)}
              </fieldset>
            </Form.Item>
          </Col>
          <Col md={12} sm={24}>
            <Form.Item>
              <fieldset className="mi_input_pop">
                <legend className="legend-font">State </legend>
                {getFieldDecorator(`statE_COMPANY_ID[${k}]`, {initialValue: k.statE_COMPANY_ID,
                  rules: [{ required: false, message: 'Please enter state ' },],
                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                  optionFilterProp="children"
                  showSearch={true}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={this.onChange}
                  placeholder="Please Select State "
                >
                  {States.map(tag => <Option value={tag.code} key={tag.code}>{tag.name}</Option>)}
                </Select>)}
              </fieldset>
            </Form.Item>

          </Col></Row>
        <Col sm={24}>


          {keys.length > 0 ? (
            <Button style={{ backgroundColor: "red", color: "white", float: "right", marginRight: "16px" }} onClick={() => this.remove(k)}> <Icon
              className="dynamic-delete-button"
              type="minus-circle-o"


            ></Icon>Remove</Button>

          ) : null}
        </Col>
      <Divider></Divider>
    </div>

    ));
    return (


      <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark >
        <Row>

        <Col sm={24}><p style={{ background: '#9982821f', padding: '10px' }} >List your insurance agency affiliations. Complete this only if the applicant is to be licensed as an active member of the business entity.</p></Col>

          <Col sm={24}>
            <Row>

              <Col md={24} sm={24}> {formItems}</Col>

              <Col md={24} sm={24}>

                <Button className=" ant-btn-primary" onClick={this.add} style={{ float: "right" }}>
                  <Icon type="plus" /> Add
                </Button>
              </Col>
            </Row>
          </Col></Row>

        <div className="collapsepanel-footer">
          <Button className=" ant-btn mi_button_right" style={{ float: "left", marginTop: "-20px", marginLeft: "-11px" }} onClick={() => this.props.back("exp")}> Back</Button>
          <Button htmlType='submit' className=" ant-btn-primary" style={{ float: "right", marginTop: "-20px", marginRight: "-11px" }}> Next</Button>
        </div>

      </Form>
    );
  }
}


const NiprAffiliations = Form.create()(EAD);

export default NiprAffiliations;